// PRICING OPTIONS: sync checkout links from data-checkout-url
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.buy-now-link[data-checkout-url]').forEach(function(link) {
        const url = link.getAttribute('data-checkout-url');
        if (url) link.href = url;
    });
});

// PROMO COUNTDOWN (3 hours)
document.addEventListener('DOMContentLoaded', function() {
    const timers = document.querySelectorAll('.promo-timer');
    if (!timers.length) return;

    let totalSeconds = 3 * 60 * 60;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
        if (totalSeconds <= 0) {
            timers.forEach(t => { t.textContent = 'Expired'; });
            clearInterval(interval);
            return;
        }
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;
        timers.forEach(t => { t.textContent = `${pad(h)}h: ${pad(m)}m: ${pad(s)}s`; });
        totalSeconds--;
    }

    tick();
    const interval = setInterval(tick, 1000);
});

// IMAGE CAROUSEL — init every gallery on the page with its own nav/pagination
var swipers = Array.from(document.querySelectorAll('.mySwiper')).map(function (el) {
    return new Swiper(el, {
        navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
        },
        pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
        },
    });
});

// FAQ ACCORDION — accordion behaviour is scoped per section, so opening a
// question in one product section does not close one in another section.
document.addEventListener('DOMContentLoaded', function() {
    function setState(item, open) {
        const answer = item.querySelector('.up-faq-answer');
        const plusIcon = item.querySelector('.up-faq-button img:first-child');
        const minusIcon = item.querySelector('.up-faq-button img:last-child');

        if (answer) answer.classList.toggle('hidden', !open);
        if (plusIcon) plusIcon.classList.toggle('hidden', open);
        if (minusIcon) minusIcon.classList.toggle('hidden', !open);
    }

    document.querySelectorAll('.up-faq-container').forEach(item => {
        const questionButton = item.querySelector('.up-faq');
        if (!questionButton) return;

        questionButton.addEventListener('click', function(e) {
            e.stopPropagation();

            const answer = item.querySelector('.up-faq-answer');
            const isOpen = answer && !answer.classList.contains('hidden');
            const scope = item.closest('section') || document;

            scope.querySelectorAll('.up-faq-container').forEach(other => {
                if (other !== item) setState(other, false);
            });

            setState(item, !isOpen);
        });
    });
});

// SUPPLEMENT FACTS POPUP
document.addEventListener('DOMContentLoaded', function() {
    const popupButtons = document.querySelectorAll('.popup-button');
    const popupOverlay = document.getElementById('supplementPopup');
    const closePopupMobile = document.getElementById('closePopupMobile');
    const closePopupDesktop = document.getElementById('closePopupDesktop');

    function openPopup() {
        popupOverlay.classList.remove('hidden');
        popupOverlay.classList.add('show');
        document.body.style.overflow = 'hidden';
    }

    function closePopup() {
        popupOverlay.classList.add('hidden');
        popupOverlay.classList.remove('show');
        document.body.style.overflow = '';
    }

    popupButtons.forEach(button => {
        button.addEventListener('click', openPopup);
    });

    if (closePopupMobile) {
        closePopupMobile.addEventListener('click', closePopup);
    }

    if (closePopupDesktop) {
        closePopupDesktop.addEventListener('click', closePopup);
    }

    popupOverlay.addEventListener('click', function(e) {
        if (e.target === popupOverlay) {
            closePopup();
        }
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popupOverlay && !popupOverlay.classList.contains('hidden')) {
            closePopup();
        }
    });
});
